import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-five-action-plan',
    templateUrl: './action-plan.component.html',
    styleUrls: ['./action-plan.component.css']
})
export class UnitFiveLessonFiveActionPlanComponent {

    title: string = "Action Plan";
    pageTitle: string = this.title + " | Unit 5, Lesson 5 | T-Folio";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }


}
